import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ShortState {
  shorts: any[];
  currentPage: number;
  hasMore: boolean;
  loading: boolean;
}

const initialState: ShortState = {
  shorts: [],
  currentPage: 1,
  hasMore: true,
  loading: false,
};

const ShortSlice = createSlice({
  name: 'short',
  initialState,
  reducers: {
    setShorts: (state, action: PayloadAction<any[]>) => {
      state.shorts = action.payload;
      state.currentPage = 1;
      state.hasMore = action.payload.length > 0;
    },
    appendShorts: (state, action: PayloadAction<any[]>) => {
      const existingIds = new Set(state.shorts.map(short => short._id));
      const uniqueNewShorts = action.payload.filter(short => !existingIds.has(short._id));
      state.shorts = [...state.shorts, ...uniqueNewShorts];
      state.currentPage += 1;
      state.hasMore = action.payload.length > 0;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    resetShorts: (state) => {
      state.shorts = [];
      state.currentPage = 1;
      state.hasMore = true;
      state.loading = false;
    },
    updateShort: (state, action: PayloadAction<any>) => {
      state.shorts = state.shorts.map(short => {
        if (short._id === action.payload._id) {
          return { ...short, ...action.payload };
        }
        return short;
      });
    },
  },
});

export const { setShorts, appendShorts, setLoading, resetShorts, updateShort } = ShortSlice.actions;
export default ShortSlice.reducer;
